<template>
    <div class="card" v-show="loaded">

        <div class="card-header border-0">
            <div class="row">
                <div class="col-6">
                    <h3 class="text-uppercase">{{ $t('users.outdated') }}</h3>
                    <small class="text-muted">{{ $t('users.outdated-meaning', { age: dataConservation }) }}</small>
                </div>
                <div class="col-6 text-right">
                    <base-button type="danger" size="sm" @click="forgetAll()">
                        <span class="btn-inner--icon"><i class="tim-icons icon-simple-remove"></i></span>
                        <span class="btn-inner--text">{{ $t('common.delete-all') }}</span>
                    </base-button>
                </div>
            </div>
        </div>

        <div class="pt-2">
            
            <table-control :paging="ctrl.paging" :search="true" v-model="search"></table-control>

            <el-table class="table-responsive table-flush"
                    header-row-class-name="thead-light"
                    :data="ctrl.rows">

                <el-table-column width="72">
                    <template v-slot="{row}">
                        <a href="#" class="avatar rounded-circle"
                                :class="{'disabled': !row.active}"
                                @click.prevent="open(row)">
                            <img :src="row.avatar">
                        </a>
                    </template>
                </el-table-column>

                <el-table-column :label="$t('common.name') + ' / ' + $t('common.email')">
                    <template v-slot="{row}">
                        <div :class="{'disabled': !row.active}">
                            <h4 class="mb-0">
                                <a href="#" @click.prevent="open(row)">
                                    {{ row.name }}
                                </a>
                                <badge type="primary" class="mr-1" v-if="$auth.user.id === row.id">
                                    {{ $t('common.me') }}
                                </badge>
                            </h4>
                            <small>
                                <a :href="'mailto:'+row.email">
                                    {{ row.email }}
                                </a>
                            </small>
                        </div>
                    </template>
                </el-table-column>

                <el-table-column :label="$t('common.creation')">
                    <template v-slot="{row}">
                        <small>
                            {{ creationDate(row) }}
                        </small>
                    </template>
                </el-table-column>

                <el-table-column :label="$t('common.client')" width="120">
                    <template v-slot="{row}">
                        <div :class="{'disabled': !row.active}" v-if="row.entity_id">
                            {{ entities[row.entity_id] }}
                        </div>
                    </template>
                </el-table-column>

                <el-table-column :label="$t('common.owner')" width="120">
                    <template v-slot="{row}">
                        <div :class="{'disabled': !row.active}" v-if="row.owner_id">
                            {{ owners[row.owner_id] }}
                        </div>
                    </template>
                </el-table-column>

                <el-table-column align="right" width="60" class-name="actions">
                    <template v-slot="{row}">
                        <a href="#" class="table-action text-danger" @click.prevent="forget(row)">
                            <i class="tim-icons icon-simple-remove"></i>
                        </a>   
                    </template>
                </el-table-column>

            </el-table>

            <table-pagination :paging="ctrl.paging"></table-pagination>
        </div>

        <portal to="modals">

            <confirm-modal v-model="ctrl.modals.confirmForget">
                <p>{{ $t('users.forget-confirm') }}</p>
            </confirm-modal>

            <confirm-modal v-model="ctrl.modals.confirmForgetAll">
                <p>{{ $t('users.forget-all-confirm') }}</p>
            </confirm-modal>

        </portal>

    </div>
</template>

<script>
    import CrudController from '@trax/classes/CrudController'
    import UserMapping from './UserMapping'
    import moment from 'moment'

    export default {

        data() {
            let mapping = new UserMapping()
            return {
                loaded: false,
                ctrl: new CrudController({
                    endpoint: '/astral/api/front/users',
                    mapData: mapping.mapData,
                    unmapData: mapping.unmapData,
                    modals: ['confirmForget', 'confirmForgetAll'],
                    paging: {
                        perPage: 10,
                        perPageOptions: [5, 10, 25, 50],
                        total: 0
                    },
                    query: {
                        sort: ['-created_at', 'lastname'],
                        include: ['roles', 'entities', 'owners'],
                        filters: { outdated: true },
                    },
                    errors: {
                        '403-delete': 'users.403-delete',
                    }
                }),
                search: '',
                entities: {},
                owners: {},
                roles: {},
                moment: moment,
            }
        },

        computed: {

            dataConservation() {
                return this.$auth['config'].data_conservation
            },

            empty() {
                return this.ctrl.rows.length == 0 && !this.search
            }
        },

        created() {
            this.ctrl.init(this, 'ctrl').then(resp => {
                this.loaded = true
                this.owners = Array.isArray(resp.data.included.owners) ? {} : resp.data.included.owners
                this.entities = Array.isArray(resp.data.included.entities) ? {} : resp.data.included.entities
                this.roles = Array.isArray(resp.data.included.roles) ? {} : resp.data.included.roles
                this.roles[0] = this.$t('common.super-admin')
            })
        },

        watch: {
            search(val) {
                this.ctrl.filterMore({ simpleSearch: val })
            }
        },

        methods: {

            forget(row) {
                this.ctrl.modals.open('confirmForget').then(confirmResponse => {
                    if (confirmResponse.confirmed) {
                        axios.post('/astral/api/front/users/'+row.id+'/forget')
                        .then(resp => {
                            this.ctrl.list()
                        })
                        .catch(err => {
                            if (err.response.status == 423) {
                                this.$notify({type: 'danger', message: this.$t('users.423-forget') })
                            } else {
                                this.$auth.handleErrorVm(err, this)
                            }
                        })        
                    }
                })
            },

            forgetAll() {
                this.ctrl.modals.open('confirmForgetAll').then(confirmResponse => {
                    if (confirmResponse.confirmed) {
                        this.$loader.show()
                        axios.delete(
                            '/astral/api/front/users',
                            { params: { filters: { outdated: true } }}
                        )
                        .then(response => {
                            this.ctrl.list()
                            this.$loader.hide()
                        }).catch(error => {
                            this.ctrl.list()
                            this.$loader.hide()
                            //this.$auth.handleErrorVm(error, this)
                        })
                    }
                })
            },

            open(row) {
                this.$router.push({ name: 'admin-user', params: { id: row.id } })
            },

            creationDate(row) {
                return this.moment(row.created_at).format('YYYY/MM/DD')
            }
        }
    }
</script>

<style scoped>

    .disabled, .disabled a {
        color: #bbb !important;
    }
    .disabled img {
        opacity: 0.5;
    }
    .card >>> td {
        padding-right: 0;
    }
    .card >>> td.actions {
        padding-left: 0;
        padding-right: 1.5rem;
    }

</style>
